export default "__VITE_ASSET__CvPrEw8g__"